import getPosition from 'Helpers/getPosition.js';
import a11yFocusTrap from 'Helpers/focusTrap.js';
import hideElements from 'Helpers/hideElements.js';

const Rail = () => {
  const body = document.querySelector('body');
  const railArea = document.querySelector('.rail-area');
  const rail = document.querySelector('.rail');
  const railToggle = document.querySelector('.rail-toggle');
  const railClose = document.querySelector('.rail-close');
  const topOffset = getPosition(railToggle);

  let lastScroll = 0;

  if (! railArea) {
    return false;
  }

  if (rail) {
    railToggle.addEventListener('click', showRail);
    railClose.addEventListener('click', hideRail);

    window.addEventListener('scroll', handleRailScroll);
  } else {
    railToggle.removeEventListener('click', showRail);
    railClose.removeEventListener('click', hideRail);

    window.removeEventListener('scroll', handleRailScroll);
  }

  function handleAriaHidden(isHidden) {
    if (isHidden) {
      railClose.removeAttribute('aria-hidden');

      hideElements('.rail-toggle, .content-area', true);
    } else {
      railClose.setAttribute('aria-hidden', 'true');

      hideElements('.rail-toggle, .content-area', false);
    }
  }

  function showRail() {
    body.classList.add('overflow-hidden');

    rail.setAttribute('role', 'dialog');
    rail.setAttribute('aria-label', 'Article Detail overlay');
    rail.classList.add('rail--is-open');

    a11yFocusTrap.trapFocus(rail, document.activeElement);
    rail.focus();

    handleAriaHidden(true);
  }

  function hideRail() {
    body.classList.remove('overflow-hidden');

    rail.classList.remove('rail--is-open');
    rail.classList.add('rail--is-closing');

    a11yFocusTrap.unTrapFocus();
    railToggle.focus();

    handleAriaHidden(false);

    setTimeout(() => {
      rail.classList.remove('rail--is-closing');
    }, 300);
  }

  function handleRailScroll() {
    const scrollPosition = getPosition(body);

    if (Math.abs(lastScroll) >= Math.abs(topOffset.y)) {
      railToggle.classList.add('rail-toggle--is-fixed');
    } else {
      railToggle.classList.remove('rail-toggle--is-fixed');
    }

    if (! window.scrollY) {
      railToggle.classList.remove('rail-toggle--is-fixed');
    }

    lastScroll = scrollPosition.y;
  }
};

export default Rail;
